require("!!/home/vagrant/buildout/resources/theme/technogenetics/node_modules/script-loader/addScript.js")(require("!!/home/vagrant/buildout/resources/theme/technogenetics/node_modules/raw-loader/index.js!/home/vagrant/buildout/resources/theme/technogenetics/node_modules/foundation-sites/dist/foundation.js"))


/*****************
 ** WEBPACK FOOTER
 ** ../~/script-loader!../~/foundation-sites/dist/foundation.js
 ** module id = 6
 ** module chunks = 0
 **/